import React from "react";
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Link,
  Chip,
} from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { useTranslation } from "i18n-fe";
import { PageLayout, StyledBreadcrumb } from "common-fe";

export default function Home() {
  const { t } = useTranslation("common");

  const apps = [
    // {
    //   title: t("home.apps.palletJack.palletJackTitle"),
    //   description: t("home.apps.palletJack.trackIncomingAndOutgoing"),
    //   icon: <PalletJack style={{ height: 40, width:"auto", minHeight: 40, minWidth: 40 }} />,
    //   url: import.meta.env.VITE_PALLETJACK_FE_URL,
    //   enabled: true,
    //   comingSoon: false,
    // },
  ];

  const breadcrumbs = [
    <StyledBreadcrumb key="home" label={t("home.appsPageTitle")} />,
  ];

  return (
    <PageLayout maxWidth={800} breadcrumbs={breadcrumbs}>
      <Stack spacing={3} width="100%">
        {apps.map((app) => (
          <Card
            key={app.title}
            sx={{
              width: "100%",
              display: "flex",
              opacity: app.enabled ? 1 : 0.5,
              transition: "transform 0.2s, box-shadow 0.2s",
              position: "relative",
              "&:hover": app.enabled
                ? {
                    transform: "translateY(-4px)",
                    boxShadow: 4,
                  }
                : {},
            }}
          >
            {app.comingSoon && (
              <Chip
                label={t("home.apps.palletJack.comingSoonLabel")}
                size="small"
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  fontWeight: "bold",
                  zIndex: 1,
                  bgcolor: "grey.400",
                  color: "common.white",
                }}
              />
            )}
            <CardActionArea
              component={app.enabled ? Link : "div"}
              href={app.enabled ? app.url : undefined}
              sx={{
                flex: 1,
                display: "flex",
                width: "100%",
                p: 2,
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "none",
                },
              }}
              disabled={!app.enabled}
            >
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{ width: "100%" }}
              >
                <Box sx={{ color: "text.primary" }}>{app.icon}</Box>
                <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                  <Typography variant="h6" gutterBottom>
                    {t("home.apps.palletJack.palletJackTitle")}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t("home.apps.palletJack.trackIncomingAndOutgoing")}
                  </Typography>
                </CardContent>
              </Stack>
            </CardActionArea>
          </Card>
        ))}
      </Stack>
    </PageLayout>
  );
}
